import React from 'react'
import {Icon, Popup} from 'semantic-ui-react'

let messageStyle = {color: 'white', background: 'rgb(227,119,55)', padding: '5px 10px'}
let messageStyle2 = {color: 'white', background: 'rgb(63,133,202)', padding: '5px 10px'}
let messageStyle3 = {color: 'white', background: 'rgb(244,195,86)', padding: '5px 10px'}
const stickyNoteStyle = {color: 'rgb(244,195,86)', marginLeft: '10px', fontSize: '18px'}
const stickyNoteStyle2 = {color: 'rgb(63,133,202)', marginLeft: '10px', fontSize: '18px'}
const stickyNoteStyle3 = {cursor: 'not-allowed', color: 'rgb(227,119,55)', marginLeft: '10px', fontSize: '18px'}

const getIsLocked = (dateText) => {
  let futureTime = new Date(dateText)
  let now = new Date()
  const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000
  const timeDiffInMs = futureTime.getTime() - now.getTime()
  let isLocked = timeDiffInMs <= thirtyDaysInMs
  return isLocked
}

const isUnlockedMarkup = (isLocked, dateText) => {
  return isLocked ? <b style={messageStyle3}><Icon name='lock open'/> ORDER IS UN-LOCKED  &nbsp; {daysUntilExfactory(dateText)} &nbsp;<Icon name='lock open'/></b> : ''
}

const isLockedMarkup = (isLocked, dateText) => {
  return isLocked ? <b style={messageStyle2}><Icon name='lock'/> ORDER IS LOCKED & WAITING FOR IMPORT TO QB &nbsp; {daysUntilExfactory(dateText)} &nbsp;<Icon name='lock'/></b> : ''
}

const isDisabledMarkup = (isDisabled) => {
  return isDisabled ? <b style={messageStyle}><Icon name='dont'/> EDITING IS DISABLED (ANY CHANGES MUST BE MANUALLY DONE IN QB !!!) &nbsp;<Icon name='dont'/></b> : ''
}

const getIsUnlocked = (dateText) => {
  return !getIsLocked(dateText)
}

const isLockedTooltip = (isLocked, dateText) => {
  return (
    isLocked
    ?
    <Popup
      size='mini'
      content={'LOCKED' + daysUntilExfactory(dateText)}
      position='bottom left'
      trigger={
        <Icon name="lock" style={stickyNoteStyle2}/>
      }
    />
    :
    null
  )
}

const isUnlockedTooltip = (isUnlocked, dateText) => {
  return (
    isUnlocked
    ?
    <Popup
      size='mini'
      content={'UNLOCKED' + daysUntilExfactory(dateText)}
      position='bottom left'
      trigger={
        <Icon name="lock open" style={stickyNoteStyle}/>
      }
    />
    :
    null
  )
}

const daysUntilExfactory = (dateText) => {
  let futureTime = new Date(dateText)
  let now = new Date()
  const timeDiffInMs = futureTime.getTime() - now.getTime()
  const timeDiffDays = Math.floor(timeDiffInMs / (24 * 60 * 60 * 1000))
  if (timeDiffDays > 0) {
    return ' (' + timeDiffDays + ' days until EX-FACTORY DATE)'
  } else {
    return ' (EX-FACTORY DATE has past)'
  }
}

export {getIsLocked, isLockedMarkup, getIsUnlocked, isDisabledMarkup, isLockedTooltip, stickyNoteStyle, isUnlockedTooltip, isUnlockedMarkup}
